import {types} from "mobx-state-tree";

export const SourceDtoModel = types.model( "SourceModel", {
    id: types.identifier, name: types.string
} );

export const SourceModel = types.model( "SourceModel", {
    value: types.identifier, label: types.string
} );
